import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonToggle, ToggleCustomEvent } from '@ionic/angular/standalone';

import { InputWrapperComponent } from '../input-wrapper/input-wrapper.component';

@Component({
    selector: 'lib-toggle',
    standalone: true,
    imports: [CommonModule, IonToggle, InputWrapperComponent],
    templateUrl: './toggle.component.html',
    styleUrl: './toggle.component.css'
})
export class ToggleComponent {
    @Input() initialValue: boolean = false;
    @Input() disabled: boolean = false;
    @Input() justify: 'start' | 'end' | 'space-between' = 'space-between';
    @Input() ionItemWrap: boolean = false;

    @Output() isChecked: EventEmitter<boolean> = new EventEmitter<boolean>();

    onChange(value: ToggleCustomEvent) {
        this.isChecked.emit(value.detail.checked);
    }
}
